import { SelectItemSearch } from '@/core/SelectItemSearch.molecule';
import { Icon } from '@seeqdev/qomponents';
import type { SelectedSearchItem } from '@/search/search.types';
import type { IconType } from '@seeqdev/qomponents';

interface SelectWorkbookProps {
  testId?: string;
  onChange: (value: SelectedSearchItem[]) => void;
  /** Selected workbook IDs */
  value: SelectedSearchItem[] | undefined;
  isMultiple?: boolean;
  title: string;
  showModal?: boolean;
  setShowModal?: (value: boolean) => void;
  setShowLocalAssetModal?: (value: boolean) => void;
  extraClassNames?: string;
  notSelectedMessage: string;
  showAddIcon?: boolean;
  allowedTypes?: string[];
  icon?: string;
  deleteIconStyle?: IconType;
}

export const SelectWorkbooks = ({
  testId = 'selectWorkbooks',
  extraClassNames,
  notSelectedMessage,
  showModal,
  isMultiple,
  value,
  title,
  onChange,
  setShowModal = () => {},
  setShowLocalAssetModal = () => {},
  showAddIcon,
  allowedTypes,
  icon = 'fc-analysis',
  deleteIconStyle,
}: SelectWorkbookProps) => {
  const clearAndClose = () => {
    setShowModal(false);
    setShowLocalAssetModal(true);
  };

  return (
    <SelectItemSearch
      testId={testId}
      value={value}
      onChange={onChange}
      onModalClose={clearAndClose}
      isMultiple={isMultiple}
      itemIcon={<Icon icon={icon} testId={`${testId}Icon`} type="inherit" extraClassNames="pl5 pr10" large={true} />}
      modalProps={{ selectionType: 'Analysis', title, allowedTypes }}
      notSelectedMessage={notSelectedMessage}
      extraValueClassNames={extraClassNames}
      showModal={showModal}
      showAddIcon={showAddIcon}
      deleteIconStyle={deleteIconStyle}
    />
  );
};
